import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {ConclusionPagesService} from './conclusion-pages.service';


@Injectable()
export class ConclusionPagesResetOnDeactivateService implements CanDeactivate<any> {

    constructor(
        private pagesService: ConclusionPagesService,
    ) {

    }

    canDeactivate() {
        this.pagesService.resetParams();
        return true;
    }
}
